import script from "./ModalDetalleInscripcion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDetalleInscripcion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDetalleInscripcion.vue?vue&type=style&index=0&id=22980a97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22980a97"]])

export default __exports__